export interface ClassData {
  id: string
  name: string
  classId: string
  students: number
  avgScore: number
  engagement: number
  progress: number
  term: string
  weeksToNextTerm: number
  status: string
  topPerformer: string
  needsSupport: string
  excellentCount: number
  strugglingCount: number
  avgSessions: number
  subjects: string[]
  recentActivities: Activity[]
  icon: "users" | "book-open" | "graduation-cap" | "flask-conical" | "microscope" | "award"
  borderColor: "primary" | "secondary"
}

export interface Activity {
  title: string
  description: string
  type: "primary" | "secondary"
}

export const classesData: ClassData[] = [
  {
    id: "1",
    name: "JSS1",
    classId: "escp-jss1-103",
    students: 42,
    avgScore: 76,
    engagement: 88,
    progress: 65,
    term: "Term 2 / 3",
    weeksToNextTerm: 4,
    status: "4 weeks to next term",
    topPerformer: "Chidimma Okoro",
    needsSupport: "Emeka Obi",
    excellentCount: 12,
    strugglingCount: 5,
    avgSessions: 24,
    subjects: [
      "Mathematics",
      "English Language",
      "Basic Science",
      "Social Studies",
      "Introductory Technology",
      "Home Economics",
    ],
    recentActivities: [
      {
        title: "Mathematics Quiz",
        description: "Completed fractions assessment",
        type: "primary",
      },
      {
        title: "Science Lab",
        description: "Plant biology experiment",
        type: "secondary",
      },
    ],
    icon: "users",
    borderColor: "primary",
  },
  {
    id: "2",
    name: "JSS2",
    classId: "escp-jss2-205",
    students: 38,
    avgScore: 72,
    engagement: 80,
    progress: 55,
    term: "Term 2 / 3",
    weeksToNextTerm: 6,
    status: "6 weeks to next term",
    topPerformer: "Blessing Akinwale",
    needsSupport: "Ibrahim Mohammed",
    excellentCount: 10,
    strugglingCount: 8,
    avgSessions: 22,
    subjects: [
      "Mathematics",
      "Integrated Science",
      "Social Studies",
      "Intro Tech",
      "Yoruba/Igbo/Hausa",
      "English Language",
      "Computer Studies",
      "Business Studies",
    ],
    recentActivities: [
      {
        title: "Social Studies Project",
        description: "Nigerian cultures presentation",
        type: "primary",
      },
      {
        title: "Computer Practical",
        description: "MS Word formatting exercise",
        type: "secondary",
      },
    ],
    icon: "book-open",
    borderColor: "secondary",
  },
  {
    id: "3",
    name: "JSS3",
    classId: "escp-jss3-311",
    students: 45,
    avgScore: 68,
    engagement: 92,
    progress: 80,
    term: "Term 2 / 3",
    weeksToNextTerm: 3,
    status: "BECE Preparation Active",
    topPerformer: "Amarachi Nwosu",
    needsSupport: "Abdullahi Sani",
    excellentCount: 15,
    strugglingCount: 6,
    avgSessions: 30,
    subjects: [
      "Mathematics",
      "English Language",
      "Basic Science",
      "Basic Technology",
      "Social Studies",
      "Civic Education",
      "Computer Studies",
      "Nigerian Language",
    ],
    recentActivities: [
      {
        title: "BECE Mock Exams",
        description: "Completed yesterday",
        type: "primary",
      },
      {
        title: "Career Workshop",
        description: 'Attended "Science vs Arts" session',
        type: "secondary",
      },
    ],
    icon: "graduation-cap",
    borderColor: "primary",
  },
  {
    id: "4",
    name: "SS1",
    classId: "escp-ss1-402",
    students: 35,
    avgScore: 65,
    engagement: 75,
    progress: 45,
    term: "Term 2 / 3",
    weeksToNextTerm: 5,
    status: "Science Stream Allocation",
    topPerformer: "Oluwaseun Adeleke",
    needsSupport: "Fatima Bello",
    excellentCount: 8,
    strugglingCount: 10,
    avgSessions: 26,
    subjects: [
      "Mathematics",
      "English Language",
      "Physics",
      "Chemistry",
      "Biology",
      "Further Mathematics",
      "Geography",
      "Economics",
    ],
    recentActivities: [
      {
        title: "Chemistry Lab Experiment",
        description: "Titration practical completed",
        type: "primary",
      },
      {
        title: "Stream Selection",
        description: "Career counseling session",
        type: "secondary",
      },
    ],
    icon: "flask-conical",
    borderColor: "secondary",
  },
  {
    id: "5",
    name: "SS2",
    classId: "escp-ss2-510",
    students: 30,
    avgScore: 78,
    engagement: 85,
    progress: 70,
    term: "Term 2 / 3",
    weeksToNextTerm: 4,
    status: "Prefect Selection Ongoing",
    topPerformer: "Chinenye Okafor",
    needsSupport: "Musa Yusuf",
    excellentCount: 14,
    strugglingCount: 4,
    avgSessions: 28,
    subjects: [
      "Mathematics",
      "English Language",
      "Physics",
      "Chemistry",
      "Biology",
      "Further Mathematics",
      "Literature",
      "Government",
    ],
    recentActivities: [
      {
        title: "Physics Practical",
        description: "Mechanics experiment",
        type: "primary",
      },
      {
        title: "Leadership Training",
        description: "Prefect orientation workshop",
        type: "secondary",
      },
    ],
    icon: "microscope",
    borderColor: "primary",
  },
  {
    id: "6",
    name: "SS3",
    classId: "escp-ss3-601",
    students: 40,
    avgScore: 82,
    engagement: 95,
    progress: 90,
    term: "Term 2 / 3",
    weeksToNextTerm: 2,
    status: "WAEC/NECO Registration",
    topPerformer: "Adebayo Ogunleye",
    needsSupport: "Aisha Lawal",
    excellentCount: 20,
    strugglingCount: 3,
    avgSessions: 35,
    subjects: [
      "Mathematics",
      "English Language",
      "Physics",
      "Chemistry",
      "Biology",
      "Further Mathematics",
      "Economics",
      "Literature",
    ],
    recentActivities: [
      {
        title: "WAEC Mock Exams",
        description: "All subjects completed",
        type: "primary",
      },
      {
        title: "University Application",
        description: "JAMB registration workshop",
        type: "secondary",
      },
    ],
    icon: "award",
    borderColor: "secondary",
  },
]
